import "./OrderDetailsModal.css";

import {
  MdClose,
  MdPerson,
  MdPhone,
  MdLocationOn,
  MdRestaurant,
  MdCurrencyRupee,
  MdAccessTime,
  MdPayments,
} from "react-icons/md";

function OrderDetailsModal({
  open,
  order,
  onClose,
}) {
  if (!open || !order) return null;

  const customerName =
    order.customerSnapshot?.name ||
    order.customerId?.name ||
    "Unknown Customer";

  const phone =
    order.customerSnapshot?.phone ||
    order.customerId?.phone ||
    "Not Available";

  const address = order.addressSnapshot
    ? `${order.addressSnapshot.addressLine1},
       ${order.addressSnapshot.city},
       ${order.addressSnapshot.state}
       - ${order.addressSnapshot.pincode}`
    : "Not Available";

  return (
    <div
      className="order-modal-overlay"
      onClick={onClose}
    >
      <div
        className="order-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="order-modal-header">
          <h2>Order Details</h2>

          <button onClick={onClose}>
            <MdClose />
          </button>
        </div>

        <div className="order-modal-body">

          <div className="detail-row">
            <MdPerson />
            <div>
              <label>Customer</label>
              <p>{customerName}</p>
            </div>
          </div>

          <div className="detail-row">
            <MdPhone />
            <div>
              <label>Phone</label>
              <p>{phone}</p>
            </div>
          </div>

          <div className="detail-row">
            <MdLocationOn />
            <div>
              <label>Delivery Address</label>
              <p>{address}</p>
            </div>
          </div>

          <div className="detail-row">
            <MdRestaurant />
            <div>
              <label>Food Items</label>

              {order.items?.map((item) => (
                <div
                  key={item._id || item.foodId}
                  style={{
                    marginBottom: "10px",
                  }}
                >
                  <strong>{item.foodName}</strong>

                  <br />

                  Qty : {item.quantity}

                  <br />

                  ₹{item.total}
                </div>
              ))}
            </div>
          </div>

          <div className="detail-row">
            <MdCurrencyRupee />
            <div>
              <label>Total Amount</label>
              <p>₹{order.grandTotal}</p>
            </div>
          </div>

          <div className="detail-row">
            <MdPayments />
            <div>
              <label>Payment</label>
              <p>{order.paymentMethod}</p>
            </div>
          </div>

          <div className="detail-row">
            <MdAccessTime />
            <div>
              <label>Ordered At</label>
              <p>
                {new Date(
                  order.createdAt
                ).toLocaleString()}
              </p>
            </div>
          </div>

          <div className="status-box">
            {order.status}
          </div>

        </div>
      </div>
    </div>
  );
}

export default OrderDetailsModal;